module.exports = __webpack_public_path__ + "img/bg_main07_mask_m.a849bcd3.svg";